import { Download } from "lucide-react";
import { useState } from "react";

import { downloadBlob } from "@/lib/download";
import type { MediaAsset } from "@/lib/types";

type Props = { media: MediaAsset[]; initialLimit?: number };

function base64ToBlob(data: string, mime: string): Blob {
  const byteChars = atob(data);
  const len = byteChars.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = byteChars.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

export function ImageGallery({ media, initialLimit = 20 }: Props) {
  const [limit, setLimit] = useState(initialLimit);
  const visible = media.slice(0, limit);

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {visible.map((m) => {
          if (!m.data_base64) return null;
          const blob = base64ToBlob(m.data_base64, m.mime);
          const url = URL.createObjectURL(blob);
          return (
            <div
              key={m.ref}
              className="group relative overflow-hidden rounded-[14px] border border-[var(--color-border)] bg-[var(--color-surface)]"
            >
              <img
                src={url}
                alt={m.ref}
                className="aspect-square w-full bg-[var(--color-surface-muted)] object-contain"
              />
              <div className="flex items-center justify-between p-3 text-xs">
                <span className="truncate text-[var(--color-ink-muted)]">{m.ref}</span>
                <button
                  type="button"
                  aria-label={`${m.ref} をダウンロード`}
                  onClick={() => downloadBlob(blob, m.ref)}
                  className="text-[var(--color-ink-muted)] hover:text-[var(--color-coral)]"
                >
                  <Download size={14} />
                </button>
              </div>
            </div>
          );
        })}
      </div>
      {media.length > limit && (
        <button
          type="button"
          onClick={() => setLimit(limit + 20)}
          className="mx-auto rounded-[10px] border border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-2 text-sm hover:bg-[var(--color-surface-muted)]"
        >
          さらに表示 ({media.length - limit} 枚残り)
        </button>
      )}
    </div>
  );
}
